/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attribute_Weight_GrossInputs */

const en_attribute_weight_gross = /** @type {(inputs: Attribute_Weight_GrossInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gross weight`)
};

/**
* | output |
* | --- |
* | "Gross weight" |
*
* @param {Attribute_Weight_GrossInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const attribute_weight_gross = /** @type {((inputs?: Attribute_Weight_GrossInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attribute_Weight_GrossInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_attribute_weight_gross(inputs)
});